export default class AuditTheme {
  palette = [
    "3c53a1", "3164ae", "3174bb", "3a85c6", "4995d1",
    "5ba5db", "70b5e4", "86c3ec", "9bd0f3", "afdcf8",
    "c2e5fb", "d2eefc", "dff4fa",
    "f9f9df", "fdeab2", "fce0a2", "fad593", "f6c785",
    "f3b878", "efa86c", "eb9662", "e68459", "e17152",
    "db5e4b", "d34c46", "c93a41", "bc2a3e", "aa1c3b"
  ];

  custom = {
    'user': 'c19531',
  };

  colorFromType(str) {
    str = str.toLowerCase();

    for (let key in this.custom) {
      if (!this.custom.hasOwnProperty(key) || key !== str) {
        continue;
      }

      return '#' + this.custom[key];
    }

    let hash = 0;
    if (str.length > 0) {
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
    }
    const index = Math.abs(hash) % this.palette.length;
    return '#' + this.palette[index];
  }
}